module.exports = {
    plan: 'Omni-D',
    startDate: new Date(2016, 11, 1, 0, 0, 0, 0),
    endDate: new Date(2017, 11, 1, 0, 0, 0, 0),
    subscription: {
        deviceId: {
            usage: 0,
            total: 300
        },
        premiumUserId: {
            usage: 0,
            total: 5000
        }
    },
    perpetual: {
        deviceId: {
            usage: 0,
            total: 300
        },
        premiumUserId: {
            usage: 0,
            total: 300
        }
    }
};



// WEBPACK FOOTER //
// ./modules/license/services/licenseManagementService.appspaceIdSummary.mock.js